import PropTypes from "prop-types";
import styled from "theme/libs/styled";

const StyledWrapper = styled("div")`
    display: grid;
    grid-template-columns: 1fr;
`;

const Waterfall = ({ children, rowGap = "0", as, ...rest }) => (
    <StyledWrapper as={as || "div"} rowGap={rowGap} {...rest}>
        {children}
    </StyledWrapper>
);

Waterfall.propTypes = {
    as: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    children: PropTypes.node.isRequired,
    rowGap: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

Waterfall.defaultProps = {
    as: undefined,
    children: <></>,
};

export default Waterfall;
